import React from "react";
import { withRouter, Redirect } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";

@withRouter
@withDefaultParams
export default class RedirectPagination extends React.PureComponent {
	render() {
		let pathname = this.props.location.pathname.split("/");
		pathname = pathname.filter((item, index) => {
			return index !== pathname.length - 1;
		});

		let redirLocation = {
			pathname: pathname.join("/"),
			search: this.props.location.search,
			state: {
				...this.props.location.state,
				isRedirect: true,
			},
		};
		return <Redirect to={redirLocation} />;
	}
}
